/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Avatar, Container } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import Fake from '../../assets/splash.png';
import api from '../../services/api';
import Header from './Header';
import Unavailability from '../../components/Unavailability';
import Body from './Body';
import Footer from './Footer';
import Detail from '../Detail';
import OrderButton from '../../components/OrderButton';
import Order from '../Order';
import Adresses from '../Adresses';

import useStyles from './styles';

export default function Store({ match }) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const { params } = match;
  const service = api(params.token || 'gf');
  const dispatch = useDispatch();
  const company = useSelector(state => state.data.company);
  const { order } = useSelector(state => state.order);

  useEffect(() => {
    async function getData() {
      try {
        const data = await service.index();
        if (data) {
          const { company, user, categories, adresses, payments } = data;

          dispatch({
            type: '@data/LOAD',
            data: {
              token: params.token,
              company,
              user,
              categories,
              payments,
            },
          });

          dispatch({
            type: '@adresses/LOAD',
            data: {
              adresses,
            },
          });

          dispatch({
            type: '@order/CREATE',
            data: {
              token: params.token,
              adresses,
            },
          });
        }
      } catch (error) {
        dispatch({ type: '@data/LOADING' });

        enqueueSnackbar(
          'Houve uma falha ao tentar consultar os dados. Tente mais tarde',
          { variant: 'error' }
        );
      }
    }

    getData();
  }, [params, dispatch]);

  function beforeLloading() {
    return (
      <Grid
        className={classes.root}
        container
        justify="center"
        alignItems="center"
      >
        <Grid item>
          <Avatar className={classes.avatar} src={Fake} alt="gf" />
        </Grid>
      </Grid>
    );
  }

  function afterLoading() {
    return (
      <Container maxWidth="xs" className={classes.root}>
        <Header background={company.background} />
        <Unavailability />
        <Body />
        <Footer />
        {order && order.items && order.items.length >= 1 && <OrderButton />}
        <Detail />
        <Order />
        <Adresses />
      </Container>
    );
  }

  return company.name ? afterLoading() : beforeLloading();
}
